export default {
  cards: {
    buttonShort: "Herunterladen",
    carbonButtonLong: "Alle Zertifikate herunterladen",
    carbonTitle: "Zertifikate",
    energyButtonLong: "Alle EPC Dateien herunterladen",
    energyTitle: "EPC Bewertungszertifikate",
    noCertificate: "Es gibt keine weitere verfügbare Zertifizierung!",
  },
  chart: {
    bronze: "DGNB-building in use-Bronze",
    carbonTitle: "Zertifizierung nach Bodenfläche",
    energyTitle: "Energiebewertung nach Grundfläche",
    gold: "DGNB-Gebäude im Einsatz-Gold",
    notCertified: "Nicht zertifiziert",
    platinum: "DGNB-building in use-Platinum",
    silver: "DGNB-building in use-silver",
  },
};
